/* eslint-disable react-hooks/exhaustive-deps */
import { Fragment, useContext, useEffect, useState } from 'react'
import axios from 'axios'

import PrimaryButton from '../../Components/Buttons/PrimaryButton'
import FormInput from '../../Components/FormInput/FormInput'
import Header from '../../Components/Header/Header'
import ImagePicker from '../../Components/ImagePicker/ImagePicker'
import Navbar from '../../Components/Navbar/Navbar'

import { toast } from 'react-hot-toast'
import { useHistory } from 'react-router-dom'
import { authContext } from '../../store/AuthContext'

const Amenities = () => {

    const serverURL = process.env.REACT_APP_SERVER_URL;
    const token = JSON.parse(localStorage.getItem('token'));

    const history = useHistory();

    const authCtx = useContext(authContext);

    if (authCtx.adminType !== 'super' && authCtx.adminType !== 'data') {
        history.push('/form');
    }

    const defaultState = {
        name: '',
        logo: null
    }

    const [amenities, setAmenities] = useState([]);
    const [currItem, setCurrItem] = useState(defaultState)

    const verifyData = () => {

        if (!currItem.name || currItem.name.length === 0) {
            return [false, "Please provide a name!"];
        }

        if (!currItem.logo || currItem.logo === null) {
            return [false, "Provide a logo!"]
        }

        return [true, ""];
    }

    const getData = async () => {

        const res = await toast.promise(
            axios({
                method: 'GET',
                url: `${serverURL}/api/amenities/`,
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }),
            {
                loading: 'Fetching...',
                success: 'Data fetched successfully!',
                error: 'Could not get the data.',
            }
        );

        if (res && res.status === 200) {
            const { data } = res.data;
            setAmenities(data);
            return;
        }

    }

    const imageChangeHandler = (file) => {
        setCurrItem((prevState) => {
            return {
                ...prevState,
                logo: file
            }
        })
    }

    const nameChangeHandler = (event) => {
        setCurrItem((prevState) => {
            return {
                ...prevState,
                name: event.target.value
            }
        })
    }

    const postData = async (event) => {

        event.preventDefault();

        const isDataVerified = verifyData();

        if (!isDataVerified[0]) {
            return toast.error(isDataVerified[1]);
        }

        const formData = new FormData();

        formData.append('name', currItem.name);
        formData.append('amenityLogo', currItem.logo)

        const res = await toast.promise(
            axios({
                method: 'POST',
                url: `${serverURL}/api/amenities/`,
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": 'multipart/form-data'
                },
                data: formData
            }), {
            loading: 'Creating...',
            success: 'Data created successfully!',
            error: 'Could not create the data.',
        }
        )

        if (res && res.status === 200) {
            const { data } = res.data;

            const newData = [...amenities];
            newData.push(data);
            setAmenities(newData);
        }

        setCurrItem(defaultState);
    }

    const deleteData = async (id) => {

        if (!id) {
            return toast.error('Please provide and ID')
        }

        try {

            const res = await toast.promise(
                axios({
                    method: 'DELETE',
                    url: `${serverURL}/api/amenities/${id}`,
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                }),
                {
                    loading: 'Deleting...',
                    success: 'Data deleted successfully!',
                    error: 'Could not delete.',
                }
            )

            if (res && res.status === 200) {

                let newData = [...amenities];
                newData = newData.filter((item) => item._id !== id);
                setAmenities(newData);
                return
            }
            return toast.error("Couldn't delete the data! Try again later.")
        } catch (error) {
            return toast.error('Something went wrong!');
        }
    }

    useEffect(() => {
        getData();
    }, [])

    return (
        <Fragment>
            <Header />
            <Navbar />
            <div className='container' >
                <div className='row'>
                    <div class="col-lg-12 mt-20">
                        <h3>Amenities</h3>
                        <hr />
                    </div>
                    <div className='col-lg-8'>
                        <table>
                            <tr>
                                <th>Title</th>
                                <th>Image</th>
                                <th class="text-center">Action</th>
                            </tr>
                            {
                                amenities && amenities.map((amenity) => {
                                    return (
                                        <tr>
                                            <td>{amenity.name}</td>
                                            <td>
                                                <img src={`${serverURL}/${amenity.logo}`} alt='table img' style={{ width: '45px', borderRadius: '4px' }} />
                                            </td>
                                            <td>
                                                <div className='flex p-relative' >
                                                    <button class="delete-btn" onClick={() => deleteData(amenity._id)} ><i className='fa fa-times'></i></button>
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </table>
                    </div>
                    <div className='col-lg-4'>
                        <h5>Add Amenities</h5>
                        <hr />
                        <form className='amenity-form side-form' >
                            <FormInput autoComplete='off' onChange={nameChangeHandler} value={currItem.name} id='name' type='text' label='Amenity Name' />
                            {currItem.name && currItem.name.length !== 0 && (
                                <Fragment>
                                    <ImagePicker onChange={imageChangeHandler} id='amenity-image' title='Select Image' />
                                    <PrimaryButton type='submit' onClick={postData} >Add</PrimaryButton>
                                </Fragment>
                            )}

                        </form>
                        <Fragment>
                            <br />
                            <strong>Image-Sizes in px (width x height)</strong>
                            <hr />
                            <p style={{ color: '#ed1a23' }} ><i>Amenities Icon - 80 x 80</i></p>
                            <br />
                        </Fragment>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Amenities